/* ==========================================================================
   FOLICULE — variant row enrichment
   Eurus's variant picker renders the option name only. This appends price,
   compare-at and a save chip to each row, using the per-variant JSON Eurus
   already prints on the page. No network request, no vendor file edits.

   It APPENDS to each label rather than rewriting it, so Eurus's Alpine
   bindings stay intact. If this script fails, the picker still works.
   ========================================================================== */
(function () {
  'use strict';

  var MONEY = function (cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '.00');
  };

  /* Variant JSON keyed by option name. This MUST be scoped to one product:
     on a page with several products (the homepage bundle builder) a global
     map lets the last product's "Single" overwrite every other product's,
     so every card rendered the same photo. */
  function readVariants(scope) {
    var out = {};
    var nodes = (scope || document).querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < nodes.length; i++) {
      var v;
      try { v = JSON.parse(nodes[i].textContent); } catch (e) { continue; }
      if (v && v.id && typeof v.price === 'number' && v.option1) out[v.option1] = v;
    }
    return out;
  }



  /* Variant image, falling back to the first gallery image so a card is never
     blank. A variant with its own image (e.g. the two-jar shot) overrides it. */
  function atWidth(src, w) {
    if (!src) return null;
    src = src.split('#')[0];
    return /[?&]width=/.test(src) ? src.replace(/([?&]width=)\d+/, '$1' + w)
                                  : src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  /* The FIRST gallery image is the product's featured image. It may be served
     as a small rendition, so upsize the URL rather than picking another image —
     "largest on the page" picks whichever graphic happens to have loaded big. */
  function variantImage(v, scope) {
    if (v.featured_image && v.featured_image.src) return atWidth(v.featured_image.src, 600);
    /* Fall back within the same product only — a document-wide lookup grabs
       whichever gallery happens to be first on the page. */
    var first = (scope || document).querySelector('.product-media-container img, .card-product img');
    return first ? atWidth(first.currentSrc || first.src, 600) : null;
  }

  /* Nearest element that represents one product. */
  function productScope(el) {
    return el.closest('.card-product, [class*="product-card"], [class*="bundle-item"], form[action*="/cart/add"]')
        || document;
  }

  function unitsIn(name) {
    var m = String(name || '').match(/(\d+)/);
    return m ? parseInt(m[1], 10) : 1;
  }

  /* Cheapest single-unit price across the option set, used as the baseline. */
  function baselineUnitPrice(variants) {
    var best = null;
    for (var k in variants) {
      if (unitsIn(k) === 1 && (best === null || variants[k].price < best)) best = variants[k].price;
    }
    return best;
  }

  function savingPercent(v, variants) {
    var base = baselineUnitPrice(variants);
    var units = unitsIn(v.option1);
    if (!base || units < 2) return 0;
    return Math.round((1 - v.price / (base * units)) * 100);
  }

  function enrich() {
    var radios = document.querySelectorAll('.input-radio');
    for (var i = 0; i < radios.length; i++) {
      var radio = radios[i];
      var scope = productScope(radio);
      var variants = readVariants(scope);
      if (!Object.keys(variants).length) variants = readVariants(document);
      if (!Object.keys(variants).length) continue;
      var label = document.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(radio.id) : radio.id) + '"]');
      if (!label || label.querySelector('.fol-row-meta')) continue;

      var v = variants[radio.value];
      if (!v) continue;

      /* Card layout: image on top, name, price, save chip. */
      var img = variantImage(v, scope);
      if (img) {
        var im = document.createElement('img');
        im.className = 'fol-card-img';
        im.src = img;
        im.alt = v.option1;
        im.loading = 'lazy';
        label.appendChild(im);
      }

      var body = document.createElement('span');
      body.className = 'fol-card-body';

      var name = document.createElement('span');
      name.className = 'fol-card-name';
      name.textContent = v.option1;
      body.appendChild(name);

      var meta = document.createElement('span');
      meta.className = 'fol-row-meta';

      var price = document.createElement('span');
      price.className = 'fol-row-price';
      price.textContent = MONEY(v.price);
      meta.appendChild(price);

      var pct = savingPercent(v, variants);
      if (pct > 0) {
        var was = document.createElement('s');
        was.className = 'fol-row-was';
        was.textContent = MONEY(unitsIn(v.option1) * baselineUnitPrice(variants));
        meta.appendChild(was);

        var chip = document.createElement('span');
        chip.className = 'fol-row-save';
        chip.textContent = 'Save ' + pct + '%';
        meta.appendChild(chip);
      }
      body.appendChild(meta);

      if (v.available === false) {
        label.classList.add('fol-row--soldout');
        var out = document.createElement('span');
        out.className = 'fol-row-out';
        out.textContent = 'Sold out';
        body.appendChild(out);
      }

      label.appendChild(body);
      label.classList.add('fol-row');
      hideBareOptionText(label);
    }
  }


  /* Eurus prints the option name as a bare span; the card supplies its own. */
  function hideBareOptionText(label) {
    for (var i = 0; i < label.children.length; i++) {
      var c = label.children[i];
      if (c.tagName !== 'SPAN') continue;
      var cls = String(c.className || '');
      if (cls.indexOf('fol-') === 0) continue;            // ours, keep
      if (cls.indexOf('absolute') !== -1) continue;       // Eurus's loading spinner
      c.style.display = 'none';                            // the duplicate name
    }
  }

  /* Eurus's featured-collection has no "exclude the current product" option,
     so the SCALP collection recommends you the page you are already on. The
     grid is plain CSS grid at every breakpoint (no slider driving it), so the
     card can simply be removed. Handle-matched, not hardcoded, so it keeps
     working for every product we add. */
  function dropSelfRecommendation() {
    var here = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!here) return;
    var sections = document.querySelectorAll('[id*="folicule_also_like"]');
    for (var s = 0; s < sections.length; s++) {
      var cards = sections[s].querySelectorAll('.card-product');
      if (cards.length < 2) continue;               // never empty the row
      for (var i = 0; i < cards.length; i++) {
        var link = cards[i].querySelector('a[href*="/products/"]');
        if (!link) continue;
        var m = link.getAttribute('href').match(/\/products\/([^\/?#]+)/);
        if (m && m[1] === here[1]) cards[i].remove();
      }
    }
  }

  function boot() {
    try { enrich(); } catch (e) { /* never break the buy box */ }
    try { dropSelfRecommendation(); } catch (e) { /* cosmetic only */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Eurus replaces the whole variant-picker element when a variant is selected,
     which wipes the enrichment. Observing the picker itself is useless — that
     node is the one being swapped out — so watch the document and re-apply.
     enrich() skips labels it has already done, so re-running is a cheap no-op. */
  var pending = null;
  var mo = new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; boot(); }, 60);
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();

/* ---------------------------------------------------------------------------
   Hero video: hydrate Eurus's deferred slideshow video on load
   ---------------------------------------------------------------------------
   Eurus renders the slideshow video inside <template x-if="intersect">, and
   flips `intersect` from an x-intersect binding on .x-container-slideshow.
   For an element that is ALREADY in the viewport when Alpine initialises, that
   binding never fires — so the hero never gets a <video> at all.

   Measured on the live site at 375px: after 20 seconds at scroll position 0,
   no <video> element exists. The visitor sees the poster image, taps it
   because it looks like a play button, and nothing happens, because there is
   nothing to play. Desktop escapes it only because people scroll.

   The fix clones the template's own content — same markup Eurus would have
   rendered, same autoplay/muted/loop/playsinline attributes — and lets the
   browser take it from there. We do not force playback policy; if the device
   blocks autoplay (iOS Low Power Mode) it blocks it, as it would have anyway.

   Vendor files are untouched. This is additive, and it no-ops the moment
   Eurus does hydrate on its own.
--------------------------------------------------------------------------- */
(function () {
  var SEL = '.video-slideshow-mobile, .video-slideshow-desktop';

  function hydrate() {
    // Which wrapper belongs to this breakpoint. Deciding by media query rather
    // than by measuring: these are absolutely positioned inside a slideshow
    // that has no height until it lays out, so an offsetWidth/offsetHeight
    // test reads 0 and skips hydration forever on most loads. That was the
    // cause of this fix working intermittently on its first two versions.
    var wide = window.matchMedia('(min-width: 768px)').matches;

    document.querySelectorAll(SEL).forEach(function (wrap) {
      var isDesktop = wrap.classList.contains('video-slideshow-desktop');
      if (isDesktop !== wide) return;          // the other breakpoint's copy
      if (wrap.querySelector('video')) return;

      var tpl = wrap.querySelector('template');
      if (!tpl || !tpl.content) return;

      var frag = tpl.content.cloneNode(true);
      var video = frag.querySelector('video');
      if (!video) return;

      // Belt and braces: iOS refuses inline autoplay without all three, and a
      // hero loop has nothing to say.
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('data-fol-hero', '1');

      tpl.parentNode.insertBefore(frag, tpl.nextSibling);

      var el = wrap.querySelector('video[data-fol-hero]');
      if (el && el.play) {
        var p = el.play();
        if (p && p.catch) p.catch(function () { /* device policy; poster stays */ });
      }
    });
  }

  // If Alpine hydrates late, two videos end up in one wrapper. Keep the first
  // — it is the one already playing — and drop the rest.
  function dedupe() {
    document.querySelectorAll(SEL).forEach(function (wrap) {
      var vids = wrap.querySelectorAll('video');
      for (var i = 1; i < vids.length; i++) {
        try { vids[i].pause(); } catch (e) {}
        vids[i].remove();
      }
    });
  }

  function run() { hydrate(); dedupe(); }

  // Fixed timers alone are not enough. Eurus builds the slideshow late and the
  // timing moves between loads — a first version of this fired at 0/400/1500ms
  // and hydrated on some page loads and not others, which looked exactly like
  // the original bug. Watch the DOM instead and hydrate whenever the markup
  // actually turns up.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var mo = new MutationObserver(function () {
    if (mo._t) return;                       // coalesce bursts
    mo._t = setTimeout(function () { mo._t = null; run(); }, 50);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Stop watching once the hero is settled, so we are not observing the whole
  // document for the life of the page.
  var stop = setInterval(function () {
    var wide = window.matchMedia('(min-width: 768px)').matches;
    var mine = [].filter.call(document.querySelectorAll(SEL), function (w) {
      return w.classList.contains('video-slideshow-desktop') === wide;
    });
    if (mine.length && mine.every(function (w) { return w.querySelector('video'); })) {
      mo.disconnect();
      clearInterval(stop);
    }
  }, 500);
  setTimeout(function () { mo.disconnect(); clearInterval(stop); }, 15000);

  // Crossing the md breakpoint swaps which wrapper is visible.
  var t = null;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(run, 250);
  });
})();
